module.exports = __webpack_public_path__ + "static/media/bg.e5d4357a.png";